import React, { useEffect, useState } from 'react';
import { Checkbox } from 'semantic-ui-react';

export interface Props {
  onToggle: (checked: boolean) => void;
  checked?: boolean;
  children?: React.ReactNode;
  checkedItemsLength?: number;
}

export const POSDeselectCheckButton = (props: Props) => {
  const [checked, setChecked] = useState(props.checked);
  const deselectIcon =
    props.checkedItemsLength && props.checkedItemsLength > 0 ? true : false;
  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  return (
    <Checkbox
      indeterminate={deselectIcon}
      onClick={() => {
        const val = !checked;
        if (!deselectIcon) setChecked(val);
        if (deselectIcon) {
          props.onToggle(false);
        } else {
          props.onToggle(val);
        }
      }}
      checked={checked}
      label={props.children}
    />
  );
};
